define((require) => {
    "use strict";

    var Backbone        = require("backbone"),
        Preconditions   = require("shared/util/Preconditions"),
        PrototypeWidget = require("ui/experience/widgets/PrototypeWidget"),
        RestApi         = require("shared/services/RestApi");

    return Backbone.Collection.extend("PrototypeWidgetCollection", {

        companyId: null,

        model: PrototypeWidget,

        constructor: function(models, options) {
            this.__super();

            if (!(options && options.companyId)) {
                Preconditions.fail("options.companyId has to be defined.");
            }
            this.companyId = options.companyId;
        },

        /**
         * Returns the REST API URL for the company's widgets.
         *
         * @returns {String}
         */
        url: function() {
            // "/api/companies/{companyId}/widgets"
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, this.companyId, RestApi.Collections.WIDGETS);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/PrototypeWidgetCollection.js